/**
 * URL de arquivo servido pela API (r7-15).
 *
 * A API devolve anexos (ex.: `user.avatar_url`) como caminho relativo —
 * `/rails/active_storage/blobs/proxy/...`. Em producao a SPA e a API estao em hosts
 * diferentes, entao o caminho cru resolveria contra o nginx da SPA e a imagem nunca
 * carregaria. Quem sabe o host da API e o bundle (`VITE_API_URL`); em dev ele e vazio e o
 * proxy do Vite encaminha `/rails` para a API.
 */
const ABSOLUTE_URL = /^(?:[a-z][a-z\d+.-]*:|\/\/)/i

export function resolveApiAssetUrl(
  url: string | null | undefined,
  apiBase: string = import.meta.env.VITE_API_URL || ''
): string | null {
  if (!url) return null
  if (ABSOLUTE_URL.test(url)) return url

  return `${apiBase.replace(/\/+$/, '')}${url.startsWith('/') ? url : `/${url}`}`
}
